import Carousel from './CarouselFigure';

export default Carousel;
